import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { scrollToId } from "@/lib/scroll";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled ? "bg-white/85 backdrop-blur-xl border-b border-black/[0.06]" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-10 h-16 sm:h-20 flex items-center justify-between gap-4">
        <a href="/" data-testid="navbar-brand-logo" className="font-display font-700 tracking-[0.25em] sm:tracking-[0.35em] text-sm sm:text-base font-bold shrink-0">
          SOLAMOVE
        </a>
        <nav className="hidden md:flex items-center gap-10 text-[11px] uppercase tracking-[0.2em] text-[#6E6A66]">
          <button data-testid="navbar-link-concept" onClick={() => scrollToId("concept")} className="hover:text-[#0D0D0D] transition-colors duration-300">Concept</button>
          <button data-testid="navbar-link-produit" onClick={() => scrollToId("produit")} className="hover:text-[#0D0D0D] transition-colors duration-300">Produit</button>
          <button data-testid="navbar-link-faq" onClick={() => scrollToId("faq")} className="hover:text-[#0D0D0D] transition-colors duration-300">FAQ</button>
        </nav>
        <button
          data-testid="navbar-prereserve-button"
          onClick={() => scrollToId("reserver")}
          className="group relative overflow-hidden shrink-0 bg-[#0D0D0D] text-[#FAF8F5] text-[10px] sm:text-[11px] uppercase tracking-[0.15em] sm:tracking-[0.2em] px-4 sm:px-6 py-2.5 sm:py-3 rounded-full"
        >
          <span className="relative z-10 transition-colors duration-500 group-hover:text-[#0D0D0D]">Pré-réserver</span>
          <span className="absolute inset-0 bg-[#CBD5C0] translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)]" />
        </button>
      </div>
    </motion.header>
  );
};
